import { render } from "./property-historynew.vue?vue&type=template&id=2b2d9555"
import script from "./property-historynew.js?vue&type=script&lang=js"
export * from "./property-historynew.js?vue&type=script&lang=js"

import "./property-historynew.vue?vue&type=style&index=0&id=2b2d9555&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__